module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mb-50"
  }, [_c('div', {
    staticClass: "why-do-more-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-star domore-yellow"
  }), _vm._v(" " + _vm._s(_vm.$t("why.exploreOneTitle")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("why.exploreOneDescription")))]), _vm._v(" "), _c('h3', [_c('i', {
    staticClass: "fa fa-star domore-yellow"
  }), _vm._v(" " + _vm._s(_vm.$t("why.exploreTwoTitle")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("why.exploreTwoDescription")))]), _vm._v(" "), _c('h3', [_c('i', {
    staticClass: "fa fa-star domore-yellow"
  }), _vm._v(" " + _vm._s(_vm.$t("why.exploreThreeTitle")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("why.exploreThreeDescription")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-star domore-blue-1"
  }), _vm._v(" " + _vm._s(_vm.$t("why.startOneTitle")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("why.startOneDescription")))]), _vm._v(" "), _c('h3', [_c('i', {
    staticClass: "fa fa-star domore-blue-1"
  }), _vm._v(" " + _vm._s(_vm.$t("why.startTwoTitle")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("why.startTwoDescription")))]), _vm._v(" "), _c('h3', [_c('i', {
    staticClass: "fa fa-star domore-blue-1"
  }), _vm._v(" " + _vm._s(_vm.$t("why.startThreeTitle")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("why.startThreeDescription")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-lg button-left",
    attrs: {
      "to": "/crowdfunding",
      "role": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t("why.exploreButton")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-lg button-right",
    attrs: {
      "to": "/start_campaign",
      "role": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t("why.startButton")))])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v("Why"), _c('span', {
    staticClass: "domore-yellow"
  }, [_vm._v("do")]), _c('span', {
    staticClass: "domore-blue-1"
  }, [_vm._v("MORE")]), _vm._v("?")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cb63e34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WhyDoMore.vue
// module id = 828
// module chunks = 1